import { get } from 'lodash';
import { combineReducers } from 'redux';

import { DEFAULT_ACTION } from '../../constants';
import * as actionTypes from './actionTypes';

const initialState = {
    isLoading: false,
    counties: []
};

export const isLoading = (state = initialState.isLoading, action = DEFAULT_ACTION) => {
    switch (action.type) {
        case actionTypes.GET_COUNTIES_SUCCESS:
        case actionTypes.GET_COUNTIES_FAIL:
            return false;
        case actionTypes.GET_COUNTIES_START:
            return true;
        case actionTypes.RESET:
            return initialState.isLoading;
        default:
            return state;
    }
};

export const counties = (state = initialState.counties, action = DEFAULT_ACTION) => {
    switch (action.type) {
        case actionTypes.GET_COUNTIES_SUCCESS:
            return action.payload;
        case actionTypes.RESET:
            return initialState.counties;
        default:
            return state;
    }
};

export const getIsLoading = state => get(state, 'isLoading', initialState.isLoading);

export const getCounties = state => get(state, 'counties', initialState.counties);

const reducer = combineReducers({
    isLoading,
    counties
});

export default reducer;
